import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";
import PublicationLinks from "../../../../../../components/Publications/components/PublicationLinks";
import { pluralize } from "../../../../../../common/helpers/helpers";

function ClingenRegions({ item }) {
  const typeCl = "tooltip-label tw-w-28 tw-pb-0";
  const tdCl = "tw-px-1 tw-border border-normal";
  const thCl = "tw-min-w-6 tw-px-1 tw-border border-normal tw-h-4 tw-relative";

  const haploPubIds = (item.data?.haploinsufficiency_pubmed_ids || "")
    .split(",")
    .filter(Boolean);
  const triploPubIds = (item.data?.triplosensitivity_pubmed_ids || "")
    .split(",")
    .filter(Boolean);

  return (
    <div>
      <div className="tw-h-3" />

      <div className="color-3 tw-w-full tw-text-2xs">
        <table className="tw-w-full">
          <thead>
            <tr className="tw-bg-blueGray-400 tw-bg-opacity-20 tw-font-bold">
              <th className={thCl}>
                <div
                  data-tooltip="Description"
                  data-tooltip-class="genome-browser-small-tooltip"
                  className="tw-absolute tw-inset-0 tw-px-1 tw-truncate"
                >
                  Description
                </div>
              </th>
              <th className={thCl}>
                <div
                  data-tooltip="Score"
                  data-tooltip-class="genome-browser-small-tooltip"
                  className="tw-absolute tw-inset-0 tw-px-1 tw-truncate"
                >
                  Score
                </div>
              </th>
              <th
                data-tooltip="Pubmed"
                data-tooltip-class="genome-browser-small-tooltip"
                className={thCl}
              >
                <div className="tw-absolute tw-inset-0 tw-px-1 tw-truncate">
                  PubMed
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={[tdCl, "tw-break-all"].join(" ")}>
                <div className="tw-font-bold">Haploinsufficiency:</div>
                {item.data?.haploinsufficiency_description ??
                  "No Description"}{" "}
              </td>
              <td className={tdCl}>
                {item.data?.haploinsufficiency_score ?? "-"}
              </td>
              <td className={tdCl}>
                <PublicationLinks
                  ids={haploPubIds}
                  className="tw-text-blue-500 tw-cursor-pointer"
                >
                  {haploPubIds?.length}{" "}
                  {pluralize(haploPubIds?.length, "PMID", "PMIDs")}
                </PublicationLinks>
              </td>
            </tr>
            <tr>
              <td className={tdCl}>
                <div className="tw-font-bold">Triplosensitivity:</div>
                {item.data?.triplosensitivity_description ?? "No Description"}
              </td>

              <td className={tdCl}>
                {item.data?.triplosensitivity_score ?? "-"}
              </td>
              <td className={`${tdCl} tw-min-w-0 tw-truncate`}>
                <PublicationLinks
                  ids={triploPubIds}
                  className="tw-text-blue-500 tw-cursor-pointer"
                >
                  {triploPubIds?.length}{" "}
                  {pluralize(triploPubIds?.length, "PMID", "PMIDs")}
                </PublicationLinks>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="tw-h-3" />

      <div className="tooltip-row">
        <div className={typeCl}>Isca Region ID</div>
        <div>{item.data.isca_id ?? "-"}</div>
      </div>

      <div className="tooltip-row">
        <div className={`${typeCl} tw-w-44`}>Isca Region Name</div>
      </div>

      <div className="tw-break-all tw-max-w-96">
        <span className="tw-mr-3">{item.data.isca_region_name ?? ""}</span>
      </div>
    </div>
  );
}

ClingenRegions.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

ClingenRegions.defaultProps = {};

export default ClingenRegions;
